import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme, { isInBroadcast: boolean }>(
  (theme) => ({
    input: {
      minWidth: 280,
      height: "36px",
      border: "1px solid",
      borderColor: theme.palette.border.default,
      borderRadius: 5,
      color: (props) => (props.isInBroadcast ? theme.palette.white : undefined),
      "&::placeholder": {
        color: (props) =>
          props.isInBroadcast ? theme.palette.events.grayTertiary : undefined,
      },
    },
    dialogContent: {
      backgroundColor: theme.palette.events.dialogHeaderBackground,
      padding: "0px !important",
    },
    title: {
      padding: "20px 0px",
    },
    dismissBtn: {
      width: "127px",
      height: "38px",
    },
    confirmBtn: {
      width: "140px",
      height: "38px",
    },
  }),
);
